import React from 'react';
import { LoadJsScript } from '../../components/LoadRemote/LoadJsScript';
import { UserPilotWindowMethods } from './types';
import { USERPILOT_TOKEN } from './constants';

declare global {
  interface Window {
    userpilot: UserPilotWindowMethods;
  }
}

export interface UserpilotProps {
  setUserpilotScriptLoaded: () => void;
}

export const Userpilot = React.memo(
  ({ setUserpilotScriptLoaded }: UserpilotProps) => {
    const onScriptLoaded = (): void => {
      setUserpilotScriptLoaded();
    };

    return (
      <LoadJsScript
        src={`https://js.userpilot.io/${USERPILOT_TOKEN}/latest.js`}
        onLoad={onScriptLoaded}
      />
    );
  }
);
